import { io } from "socket.io-client";

const baseurl = "https://sapi.monteserenohealth.org";
let socket = null;

export const initializeSocket = (userId) => {
  if (!socket) {
    socket = io(baseurl, {
      transports: ["websocket"],
      query: { userId },
    });

    socket.on("connect", () => {
      console.log("🔗 Socket Connected:", socket.id);
      // localStorage.setItem('socketId', JSON.stringify(socket))
      socket.emit("usersocket", { id: userId }, (response) => {
        if (response.success) {
          console.log("Userregisteredonsocket", response);
        } else {
          console.error(
            "🔴 Failed to register user on socket:",
            response.message || response.error
          );
        }
      });
    });

    socket.on("disconnect", () => {
      console.log("❌ Socket Disconnected");
    });
  }
  return socket;
};

export const getSocket = () => {
  if (!socket) {
    console.warn(
      "⚠️ Socket not initialized! Call initializeSocket(userId) first."
    );
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log("🔌 Socket disconnected manually");
  }
};
